
import * as entryServer from "/home/jtuser/Desktop/usn-discount-free-product/app/entry.server.jsx";
import * as route0 from "./root.jsx";
import * as route1 from "./routes/app.volume-discount.$functionId.$id.jsx";
import * as route2 from "./routes/app.volume-discount.$functionId.new.jsx";
import * as route3 from "./routes/app.additional.jsx";
import * as route4 from "./routes/app._index.jsx";
import * as route5 from "./routes/auth.login/route.jsx";
import * as route6 from "./routes/webhooks.jsx";
import * as route7 from "./routes/_index/route.jsx";
import * as route8 from "./routes/auth.$.jsx";
import * as route9 from "./routes/app.jsx";
  export { default as assets } from "@remix-run/dev/assets-manifest";
  export const assetsBuildDirectory = "public/build";
  export const future = {"v2_dev":{"port":"43287"},"unstable_postcss":false,"unstable_tailwind":false,"v2_errorBoundary":true,"v2_headers":true,"v2_meta":true,"v2_normalizeFormMethod":true,"v2_routeConvention":true};
  export const publicPath = "/build/";
  export const entry = { module: entryServer };
  export const routes = {
    "root": {
      id: "root",
      parentId: undefined,
      path: "",
      index: undefined,
      caseSensitive: undefined,
      module: route0
    },
  "routes/app.volume-discount.$functionId.$id": {
      id: "routes/app.volume-discount.$functionId.$id",
      parentId: "routes/app",
      path: "volume-discount/:functionId/:id",
      index: undefined,
      caseSensitive: undefined,
      module: route1
    },
  "routes/app.volume-discount.$functionId.new": {
      id: "routes/app.volume-discount.$functionId.new",
      parentId: "routes/app",
      path: "volume-discount/:functionId/new",
      index: undefined,
      caseSensitive: undefined,
      module: route2
    },
  "routes/app.additional": {
      id: "routes/app.additional",
      parentId: "routes/app",
      path: "additional",
      index: undefined,
      caseSensitive: undefined,
      module: route3
    },
  "routes/app._index": {
      id: "routes/app._index",
      parentId: "routes/app",
      path: undefined,
      index: true,
      caseSensitive: undefined,
      module: route4
    },
  "routes/auth.login": {
      id: "routes/auth.login",
      parentId: "root",
      path: "auth/login",
      index: undefined,
      caseSensitive: undefined,
      module: route5
    },
  "routes/webhooks": {
      id: "routes/webhooks",
      parentId: "root",
      path: "webhooks",
      index: undefined,
      caseSensitive: undefined,
      module: route6
    },
  "routes/_index": {
      id: "routes/_index",
      parentId: "root",
      path: undefined,
      index: true,
      caseSensitive: undefined,
      module: route7
    },
  "routes/auth.$": {
      id: "routes/auth.$",
      parentId: "root",
      path: "auth/*",
      index: undefined,
      caseSensitive: undefined,
      module: route8
    },
  "routes/app": {
      id: "routes/app",
      parentId: "root",
      path: "app",
      index: undefined,
      caseSensitive: undefined,
      module: route9
    }
  };